/**
 * Matches a leading list marker: 1. 1) 12. a. iv) - * or a bullet.
 *
 * Requires whitespace after the marker so a sentence opening "1st of the month" or a price like
 * "1.50 per unit" is not mistaken for a list item.
 */
const MARKER = /^(\d{1,3}[.)]|[a-zA-Z][.)]|[-*•–])\s+/;
/**
 * Whether a line is just restating the heading it sits under.
 *
 * Compared with punctuation and case thrown away, because the line people paste is "Terms and
 * Conditions:" and the heading above it is "Terms and Conditions" — the colon is the only
 * difference and it is not a meaningful one.
 */
function restatesHeading(text, heading) {
    const normalise = (value) => value
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    return normalise(text) === normalise(heading);
}
export function parseClauses(text, 
/**
 * The heading this text is printed under, when it has one.
 *
 * WHY THIS IS WORTH THE PARAMETER. Terms get pasted out of an existing document, and that
 * document had "Terms and Conditions:" written across the top of them — so the block ends up
 * announcing itself twice, once in the section heading and again in its own first line. It
 * reads as a mistake because it is one, and it will happen to every brand that pastes rather
 * than types.
 *
 * DROPPED ONLY WHEN IT CARRIES NOTHING: the very first line, with no list marker, saying
 * exactly what the heading above it already says. A clause with a marker is never touched,
 * and neither is anything further down — those are the brand's words and might say anything.
 */
heading) {
    if (!text)
        return [];
    const clauses = text
        .split(/\r?\n/)
        .map((line) => line.trim())
        // Blank lines were spacing in a textarea; the layout provides its own.
        .filter((line) => line.length > 0)
        .map((line) => {
        const match = MARKER.exec(line);
        if (!match)
            return { marker: null, text: line };
        return { marker: match[1], text: line.slice(match[0].length) };
    });
    const [first] = clauses;
    if (heading && first && !first.marker && restatesHeading(first.text, heading)) {
        return clauses.slice(1);
    }
    return clauses;
}
//# sourceMappingURL=clauses.js.map